export class GrantPassword {

    username:string;
    password:string;
    // grant_type:string;
    // client_id:number;
    // url:string;
    // ip_adress:string;
    // city:string;
    // postal:string;
    // state:string;
    // country_name:string;
    // connection:string;

    constructor() {
        this.username = "";
        this.password = "";
    }


}
